module.exports = __webpack_public_path__ + "static/theme-fx.e72f8d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme-fx.png
// module id = 475
// module chunks = 168707334958949